import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { fetchMe, login as apiLogin, register as apiRegister, logout as apiLogout } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // undefined = checking, null = anonymous, object = signed in
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const me = await fetchMe();
      setUser(me);
      return me;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const me = await apiLogin(email, password);
    setUser(me);
    return me;
  };

  const register = async (email, password, name, acceptedTerms) => {
    const me = await apiRegister(email, password, name, acceptedTerms);
    setUser(me);
    return me;
  };

  const logout = async () => {
    try {
      await apiLogout();
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};
